"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const layout_1 = require("../layout");
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const loading_1 = require("../loading");
const utilities_1 = require("../utilities");
const daterange_picker_1 = require("../daterange-picker");
const presets_1 = require("../daterange-picker/presets");
const { parse, stringify } = require("query-string");
const PaddedDiv = styled_components_1.default.div `
  padding-bottom: 10px;
`;
const presets = [
    {
        text: "Last 90d",
        start: moment_1.default.utc().subtract(90, "days"),
        end: moment_1.default.utc()
    },
    {
        text: "Last 30d",
        start: moment_1.default.utc().subtract(30, "days"),
        end: moment_1.default.utc()
    },
    {
        text: "Last 7d",
        start: moment_1.default.utc().subtract(7, "days"),
        end: moment_1.default.utc()
    }
];
class CategoryDashboardLayoutView extends React.Component {
    constructor(props) {
        super(props);
        this.getDefaultProps = () => this.props.selectableDates === "future"
            ? CategoryDashboardLayoutView.defaultFutureDates
            : CategoryDashboardLayoutView.defaultPastDates;
        this.validateStartEndDates = () => {
            const { startDate, endDate } = parse(this.props.location.search);
            const start = moment_1.default.utc(startDate, "YYYY-MM-DD");
            const end = moment_1.default.utc(endDate, "YYYY-MM-DD");
            const today = moment_1.default.utc();
            if (!start.isValid() ||
                !end.isValid() ||
                end.diff(start, "days") < 0 || // End date is before start date
                (this.props.selectableDates === "past" && today.diff(end, "days") < 0) || // only past dates are selected
                (this.props.selectableDates === "future" && start.diff(today, "days") < 0) // only future dates are selected
            ) {
                return {
                    valid: false,
                    start: this.getDefaultProps().defaultStartDate,
                    end: this.getDefaultProps().defaultEndDate
                };
            }
            return { valid: true, start, end };
        };
        this.updateQueryParams = (startDate, endDate) => {
            const queryParams = parse(this.props.location.search);
            const defaultQuery = stringify(Object.assign(Object.assign({}, queryParams), { startDate: startDate.format("YYYY-MM-DD"), endDate: endDate.format("YYYY-MM-DD") }));
            this.props.history.push(`${this.props.location.pathname}?${defaultQuery}`);
        };
        const { start, end, valid } = this.validateStartEndDates();
        if (!valid) {
            this.updateQueryParams(start, end);
        }
        this.handleDatesChange = this.handleDatesChange.bind(this);
    }
    componentDidUpdate(oldProps) {
        const { start, end, valid } = this.validateStartEndDates();
        if (!valid) {
            this.updateQueryParams(start, end);
        }
    }
    handleDatesChange({ startDate, endDate }) {
        if (!startDate || !endDate) {
            return;
        }
        this.updateQueryParams(startDate, endDate);
    }
    render() {
        const { id, title, selectableDates } = this.props;
        const { start, end, valid } = this.validateStartEndDates();
        if (!valid) {
            return React.createElement(loading_1.Spinner, null);
        }
        return (React.createElement(layout_1.CategoryPageLayout, { id: id, title: title, actions: React.createElement(PaddedDiv, null,
                React.createElement(daterange_picker_1.DateRangePicker, { daySize: 40, showClearDates: true, reopenPickerOnClearDates: true, selectableDates: selectableDates, numberOfMonths: 1, startDate: start, endDate: end, onDatesChange: this.handleDatesChange, renderCalendarInfo: () => (React.createElement(presets_1.Presets, { presets: presets, handleDatesChange: this.handleDatesChange })) })) }, typeof this.props.children === "function" &&
            this.props.children(start, end)));
    }
}
exports.CategoryDashboardLayoutView = CategoryDashboardLayoutView;
CategoryDashboardLayoutView.defaultFutureDates = {
    defaultStartDate: moment_1.default.utc(),
    defaultEndDate: moment_1.default.utc().add(7, "days")
};
CategoryDashboardLayoutView.defaultPastDates = {
    defaultStartDate: moment_1.default.utc().subtract(7, "days"),
    defaultEndDate: moment_1.default.utc()
};
CategoryDashboardLayoutView.defaultProps = {
    selectableDates: "past"
};
exports.CategoryDashboardLayout = utilities_1.compose(react_router_dom_1.withRouter)(CategoryDashboardLayoutView);
